<template>
  <div>
    <a-table
      :columns="getHeaders()"
      :table-data="users"
      :filter-columns="['userName', 'name', 'email']"
      :search-field-label="$t('Security.UserImpersonation.User')"
      item-key="id"
      show-pointer
      @row-click="rowClick"
      @search="executeSearch($event)"
    />
    <impersonation-dialog v-model="dialog" :user="clickedUser" />
  </div>
</template>

<script>
import Table from "+/components/table/Table";
import ImpersonationDialog from "./components/impersonation-dialog";
import Users from "./graphql/UsersQuery.gql";
import { hasManagementRole } from "@/config/keycloak/keycloakUser.js";
import { redirectIfNoAccess } from "@/config/router.js";
import SettingsQuery from "./graphql/SettingsQuery.gql";
import apolloProvider from "@/apollo/provider.js";

export default {
  beforeRouteEnter(to, from, next) {
    apolloProvider.clients.config
      .query({
        query: SettingsQuery
      })
      .then(
        ({ data: { getSettings: { keycloakEnableUserImpersonation } } }) => {
          redirectIfNoAccess(
            hasManagementRole("manage-users") && hasManagementRole("impersonation") && keycloakEnableUserImpersonation,
            next
          );
        }
      );
  },  
  components: {
    "impersonation-dialog": ImpersonationDialog,
    "a-table": Table
  },
  data: () => ({
    users: [],
    search: "",
    clickedUser: {},
    dialog: false
  }),
  methods: {
    rowClick({ row }) {
      if (!(row && row._row && row._row.data)) {
        return;
      }
      const user = row._row.data;
      this.clickedUser = user;
      this.dialog = true;
    },
    getHeaders() {
      return [
        {
          title: this.$t("Security.UserAdministration.UserName"),
          field: "userName",
          value: "userName"
        },
        {
          title: this.$t("Security.UserAdministration.User"),
          field: "name",
          value: "name"
        },
        {
          title: this.$t("Security.UserAdministration.Email"),
          field: "email",
          value: "email"
        }
      ];
    }
    ,
    executeSearch(search) {

      let client = this.$apollo.provider.clients.security

      client.query({
        query: Users,
        variables: {
          search: search
        }})
      .then(({ data: { users }}) => {
        if (users && users.length) {
          const requestedUsers = users.map((user) => ({
            id: user.id,
            name: `${user.lastName}, ${user.firstName}`,
            email: user.email,
            userName: user.userName,
            userType: user.userType,
            impersonateable: user.impersonateable,
            __typename: user.__typename,
            firstName: user.firstName,
            lastName: user.lastName
          }));

          this.users = requestedUsers
            .filter((user) => user.impersonateable)
            .sort((a, b) => {
              if (a.name > b.name) return 1;
              if (b.name > a.name) return -1;
              return 0;
            });
        } else {
          this.users = []
        }
    })
    }
  }
};
</script>
